export interface Typography {
    fontFamily: string;
}

export interface TypographyOptions {
    fontFamily?: string;
}

export default function createTypography(options: Partial<TypographyOptions> = {}): Typography {
    const fontFamily = options.fontFamily || '"Roboto", sans-serif';

    return {
        fontFamily,
    };
}
